import { createContext, useContext } from "react";
import { Outlet } from "react-router-dom";
import { useComplexState } from "use-complex-state";
import { HeatReportReducer } from "./HeatReportReducer";

const HeatReportContext = createContext({
	state: HeatReportReducer.getInitialState(),
	actions: HeatReportReducer.actions,
});

export const useHeatReportContext = () => useContext(HeatReportContext);

export const CasterHeatReportProvider = () => {
	const [state, actions] = useComplexState({
		initialState: HeatReportReducer.getInitialState(),
		reducers: HeatReportReducer.caseReducers,
	});

	return (
		<HeatReportContext.Provider value={{ state, actions }}>
			<Outlet />
		</HeatReportContext.Provider>
	);
};
